export const MSA_SECTIONS = {
  operations: null,
  query: {
    label: "CMS Query Information",
  },
  "rated-age": {
    label: "Rated Age",
  },
  "medical-review": {
    label: "Medical Review",
  },
  "legal-review": {
    label: "Legal Review",
  },
  invoice: {
    label: "Invoice Information",
  },
  "client-delivery": {
    label: "Client Delivery Information",
  },
  "cms-submission": {
    label: "CMS Submission",
  },
  "invoice-cms": {
    label: "Invoice Information",
  },
  "cms-status": {
    label: "CMS Status",
  },
  fsd: {
    label: "Final Settle Documents",
  },
  "audit-history": {
    label: "Audit History",
  },
} as const;

export const MCP_SECTIONS = {
  query: {
    label: "CMS Query Information",
    path: "query",
  },
  "medical-review": {
    label: "Medical Review",
    path: "medical-review",
  },
  "legal-review": {
    label: "Legal Review",
    path: "legal-review",
  },
  "client-delivery": {
    label: "Client Submission",
    path: "client-delivery",
  },
  "cms-status": {
    label: "CMS Status",
    path: "cms-status",
  },
  "audit-history": {
    label: "Audit History",
    path: "audit-history",
  },
} as const;

export const ARS_SECTIONS = {
  operations: {
    label: "Operations",
  },
  "amended-review": {
    label: "10/10 Review",
  },
  analysis: {
    label: "Client Analysis",
  },
  invoice: {
    label: "Invoice",
  },
  "audit-history": {
    label: "Audit History",
  },
} as const;
